import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useState } from "react";

import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import NoteState from "./context/notes/NoteState";
import Alert from "./components/Alert";
import Signup from "./components/Signup";
import Login from "./components/Login";

function App() {
  const [alert, setAlert] = useState(null);

  // 🔔 Show Alert function
  const showAlert = (msg, type) => {
    setAlert({ msg, type });

    setTimeout(() => {
      setAlert(null);
    }, 2000);
  };

  return (
    <NoteState>
      <Router>
        <Navbar />

        {/* 🔔 Dynamic Alert */}
        <Alert alert={alert} />

        <div className="container">
          <Routes>
            {/* 🔐 Protected Route */}
            <Route
              path="/"
              element={
                localStorage.getItem("token") ? (
                  <Home showAlert={showAlert} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />

            <Route path="/about" element={<About />} />

            {/* 🚪 Auth Routes */}
            <Route
              path="/login"
              element={
                !localStorage.getItem("token") ? (
                  <Login showAlert={showAlert} />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/signup"
              element={
                !localStorage.getItem("token") ? (
                  <Signup showAlert={showAlert} />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
          </Routes>
        </div>
      </Router>
    </NoteState>
  );
}

export default App;
